import type { ReactNode } from 'react';

type TrackingCardProps = {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
};

export function TrackingCard({ title, subtitle, children }: TrackingCardProps) {
  return (
    <section className="rounded-xl border border-border bg-card p-6">
      <div>
        <h2 className="text-lg leading-none font-medium md:leading-tight">{title}</h2>
        {subtitle && <div className="mt-0.5">{subtitle}</div>}
      </div>
      <div className="mt-4">{children}</div>
    </section>
  );
}
